<template>
    <div>
        <div class="widgets-header bg-muted row">
            <div class="ibox-heading clearfix">
                <h1 v-if="loading">{{ t_fonts }}</h1>
                <h1 v-else>
                    {{ `${t_fonts} (${fontscount})` }}
                    <span>
                        <v-btn
                            aria-label="add font"
                            v-if="multiSelect.ids.length > 0"
                            type="button"
                            class="btn btn-primary inline-block m-l-sm button-multidelete-widget"
                            @click="showDeleteFontsModal()" v-cloak>
                            <i class="fa-regular fa-trash fa-lg"></i>
                        </v-btn>
                        <v-btn aria-label="save font"
                            v-if="saveable" type="button" class="btn btn-primary inline-block m-l-sm button-save-fonts" @click="saveFonts()" v-cloak>
                            <i class="fa-regular fa-save fa-lg"></i>
                        </v-btn>
                        <v-btn aria-label="add font"
                            type="button" class="btn btn-primary inline-block m-l-sm button-add-font" @click="showAddFontsModal(0)" v-cloak>
                            <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
                             {{ t_add_to_current_project }}
                        </v-btn>
                    </span>
                </h1>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="ibox relative widgets">
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-lg-12 animated fadeIn">
                                <div class="row">
                                    <div class="load-widget-notifications">
                                        <div class="alert alert-danger hidden">
                                            {{ t_fonts_not_loaded }}
                                        </div>
                                    </div>
                                    <list :fonts="fonts" :loading="loading" :superadmin="superadmin"></list>
                                </div>
                            </div>
                        </div>
                        <add-fonts-modal id="dz-add-fonts" :fonts="fonts"></add-fonts-modal>
                        <delete-fonts-modal></delete-fonts-modal>
                    </div>
                </div>
            </div>
        </div>
        <v-btn v-if="superadmin" type="button" class="btn btn-primary inline-block m-l-sm button-add-font" @click="showAddFontsModal(1)">
            <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
            {{ t_add_to_all_projects }}
        </v-btn>
    </div>
</template>

<script>
    export default {
        props: [
            'add',
            'superadmin',
        ],
        components: {
            addFontsModal: require('./add-fonts-modal.vue').default,
            deleteFontsModal: require('./delete-fonts-modal.vue').default,
            list: require('./list').default,
        },
        data: function () {
            return {
                t_fonts: Lang.langGet('Fonts'),
                t_fonts_not_loaded: Lang.langGet('Fonts not loaded'),
                t_add_to_all_projects: Lang.langGet('Add font to ALL projects'),
                t_add_to_current_project: Lang.langGet('Add font to current project'),

                files: [],
                loading: true,
                multiSelect: {
                    names: [],
                    ids: []
                },
                mode: 'tiles',
                sort_by: '',
                sort_dir: 'asc',
                date_format_mapping: {
                    'dd.MM.yyyy': 'DD.MM.yyyy',
                    'MM/dd/yyyy': 'MM.DD.yyyy'
                },
                fonts: [],
                saveable: false,
            }
        },
        computed: {
            fontscount: function () {
                return this.fonts.length;
            }
        },
        methods: {
            fetchFonts: function (data=null) {
                let keyword = '';
                this.loading = true;
                this.widgets = [];

                if (data !== null) {
                    keyword = data.keyword;
                }

                axios.post('/administration/font/get', {
                    id: Laravel.activeProject,
                    keyword: keyword,
                }).then((response) => {
                    this.loading = false;
                    this.fonts = response.data.data.fonts;
                    this.edited = false;
                }).catch((error) => {
                    this.loading = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                });
            },
            showAddFontsModal: function (global) {
                EaseEventBus.fire('showAddFontsModal', global);
            },
            showDeleteFontsModal: function () {
                EaseEventBus.fire('multiDeleteFonts', this.multiSelect);
            },
            saveFonts() {
                EaseEventBus.fire('fonts-save');
            }
        },
        mounted() {
            this.fetchFonts();

            EaseEventBus.listen('selectFonts', (data) => {
                this.$nextTick(() => {
                    if (data.selected) {
                        this.multiSelect.ids.push(data.id);
                        this.multiSelect.names.push(data.name);
                    } else {
                        var i = this.multiSelect.ids.indexOf(data.id);
                        if(i >= 0) {
                            this.multiSelect.ids.splice(i, 1);
                            this.multiSelect.names.splice(i, 1);
                        }
                    }
                });
            });

            EaseEventBus.listen('updateFontsData', (data=null) => {
                this.fetchFonts(data);
            });

            EaseEventBus.listen('startSearch', (data) => {
                this.fetchFonts(data);
            });

            EaseEventBus.listen('fonts-saveable', (saveable) => {
                this.saveable = saveable;
            });
            EaseEventBus.listen('fonts-save-done', () => {
                this.saveable = false;
                this.fetchFonts();
            });
        }
    }
</script>
